import { useMemo } from 'react';
import { inject, observer } from 'mobx-react';
import { getName, isEmpty } from '@/utils';
import LazyLoadImg from '@/components/LazyLoadImg';
import { formatPriceThousands } from '@/utils/configs/price.config';
import ThirdPartyPlatformConfig from '@/utils/configs/ThirdPartyPlatform.config';
import styles from './index.module.less';
import { cloneDeep } from 'lodash';
import cls from 'classnames';
import ossImgCompress from '@/utils/ossImgCompress';
import { usePrimeBtnContext } from '@/pages/product/usePrimeBtnContext';

/**
 * 套餐内的赠品列表数据
 * @param {number} cid 不传自动取curSelectCommodityId
 * @param {object} style
 */
export default inject(
  'product',
  'app',
  'area'
)(
  observer((props) => {
    const {
      product: { productGiftsMap, curSelectCommodityId, productDetail },
      cid = curSelectCommodityId,
      style = {},
      app: {
        webp,
        campaign: { curProductSelectSizeCInfo: giftTShirt },
      },
      area: { country, LANG },
    } = props;

    const { isPrimeBtnVisible } = usePrimeBtnContext();

    // 获取当前套餐的赠品
    const gifts = useMemo(() => {
      const extraGifts = [];
      // 处理T恤的数据
      if (!isEmpty(giftTShirt)) {
        const tShirt = cloneDeep(giftTShirt);
        tShirt.displayUrl = giftTShirt?.displays?.[0]?.url;
        tShirt.commodityName = giftTShirt?.product_name;
        tShirt.number = 1;
        extraGifts.push(tShirt);
      }
      return productGiftsMap[cid] || extraGifts.length
        ? [...extraGifts, ...(productGiftsMap[cid]?.activityGift ?? []), ...(productGiftsMap[cid]?.resellerGift ?? [])]
        : null;
    }, [cid, productGiftsMap, giftTShirt]);

    const isRedirect = useMemo(() => {
      const redirectData = ThirdPartyPlatformConfig.getRedirectData({
        pid: productDetail.id,
        cid: curSelectCommodityId,
      });
      return !!redirectData?.text;
    }, [curSelectCommodityId]);

    if (isEmpty(gifts) || isRedirect) return null;

    return (
      <div className={styles.giftsWrap} style={style}>
        <div className={styles.giftTitle}>{LANG['common.tag.gift']}</div>

        {gifts?.map((gift) => {
          const cName = getName(gift.commodityName, 'split');

          return (
            <div className={cls([styles.giftItem, styles.item])} key={gift.commodityId}>
              <LazyLoadImg
                className={styles.imgWrap}
                alt=''
                src={ossImgCompress(gift.displayUrl, {
                  width: 80,
                  height: 80,
                  format: webp ? 'webp' : 'jpg',
                })}
              />
              <div className={styles.textWrap}>
                <div className={styles.text}>
                  {LANG[`navigation.SpecialProductName.${gift?.commodityId}`] || cName}
                  <div className={styles.priceWrap}>
                    <div className={styles.price}>
                      {formatPriceThousands({
                        price: 0,
                        signal: gift.price.signal,
                        currency: gift.price.currency,
                        country,
                      })}
                    </div>
                    {!isEmpty(gift.price) && (
                      <div className={styles.origin}>
                        {formatPriceThousands({
                          // 赠品如果有原价则显示原价，没有则显示现价
                          price: gift?.originPrice?.amount || gift?.origin_price?.amount || gift.price.amount,
                          signal: gift.price.signal,
                          currency: gift.price.currency,
                          country,
                        })}
                      </div>
                    )}
                  </div>
                </div>
                <div className={styles.number}>× {gift.number}</div>
              </div>
            </div>
          );
        })}
        {isPrimeBtnVisible && <div className={styles.tips}>* Not eligible for Buy with Prime orders.</div>}
      </div>
    );
  })
);
